import { Fragment } from "react";

import BaseComponent from "@js/components/base_component.jsx";
import TwoFactor from "@js/components/eui/users/twofactor.jsx";
import PasswordRequirements from "@js/components/eui/users/password_requirements.jsx";

class EuiUserSettingsForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      isChangingPassword: props.entity.editing_password,
    };
  }

  render() {
    return (
      <div className="form-horizontal">
        <ErrorBanner entity={ this.props.entity } />

        <Panel heading="user_details">
          { this._renderPasswordChange() }

          <TwoFactor
            entity={ this.props.entity }
            library={ this.props.library }
            editing={ this.props.editing }
          />
        </Panel>
      </div>
    );
  }

  _renderPasswordChange() {
    if ( !this.props.editing ) {
      return (
        <FieldContainer labelText="Password">
          <a
            href={ Routes.edit_eui_user_setting_path(this.props.library.current_user.id, { editing_password: "1" }) }
          >{ t("phrases.click_here_to_change_your_password") }</a>
        </FieldContainer>
      );
    }

    if ( !this.state.isChangingPassword ) {
      return (
        <FieldContainer labelText="Password">
          <a
            href="#"
            onClick={ (e) => { e.preventDefault(); this.setState({ isChangingPassword: true }); } }
          >{ t("phrases.click_here_to_change_your_password") }</a>
        </FieldContainer>
      );
    }

    return (
      <Fragment>
        <input
          type="hidden"
          name="eui_user_settings[editing_password_confirmed]"
          value="1"
        />
        <InputField
          object={ this.props.entity }
          type="eui_user_settings"
          field="current_password"
          editing={ this.props.editing }
          password={ true }
        />
        <InputField
          object={ this.props.entity }
          type="eui_user_settings"
          field="new_password1"
          editing={ this.props.editing }
          password={ true }
        />
        <InputField
          object={ this.props.entity }
          type="eui_user_settings"
          field="new_password2"
          editing={ this.props.editing }
          password={ true }
        />
        <PasswordRequirements />
        <hr/>
      </Fragment>
    );
  }

}

export default EuiUserSettingsForm;
